import React, { Component } from "react";

let ChannelStore = class Unit extends Component{
  render(){
    return <div>This is store</div>
  }
}

export default ChannelStore;


// WEBPACK FOOTER //
// ./src/containers/application/ChannelStore.js